import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { PLAIN_SETTING_FOR_DESIGN_PLAIN_QUERY } from "./schema";

export const usePlainSettingQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(PLAIN_SETTING_FOR_DESIGN_PLAIN_QUERY, { variables: { hotelID } });

	return {
		plainSettingForDesignPlain: data,
	};
};
